import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import UpdateCustomFieldDefinitionMutation from '../../../../../mutations/ticketing/admin/useUpdateCustomFieldDefinitionMutation';

export interface UpdateCustomFieldDefinitionInput {
	id: string;
	name?: string;
	options?: string[];
	readOnly?: boolean;
	requiredOnResolution?: boolean;
}

export function useUpdateCustomFieldDefinition() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function update(input: UpdateCustomFieldDefinitionInput): Promise<void> {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				UpdateCustomFieldDefinitionMutation,
				input,
				() => {
					setLoading(false);
					resolve();
				},
				err => {
					setLoading(false);
					const msg = err instanceof Error ? err.message : String(err);
					setError(msg);
					reject(err);
				}
			);
		});
	}

	return {update, loading, error, setError};
}
